import React, { useState } from 'react';

import IconDropdown from '../../../images/Header/icon_dropdown.svg';

import { Link } from '../../Link';

import * as S from './styles';

const Tab = ({ tabItems, tabTitle, image }) => {
  const [isTabOpen, setIsTabOpen] = useState(false);

  const handleTab = () => {
    setIsTabOpen((oldIsTabOpen) => !oldIsTabOpen);
  };

  return (
    <S.Tab>
      <input onChange={handleTab} type="checkbox" checked={isTabOpen} />
      <S.TabButton onClick={handleTab}>
        {image ? <img src={image} alt={tabTitle} /> : null}
        {tabTitle}
        <img src={IconDropdown} alt="Icon dropdown" />
      </S.TabButton>
      <S.TabContainer>
        <S.TabContent>
          {tabItems?.map(({ asLinkFromGatsby, path, name, subtitle, image, sendEvent }) => (
            <div key={name}>
              {asLinkFromGatsby ? (
                <Link to={path} alt={name} onClick={() => sendEvent({ cta: tabTitle, subMenu: name })}>
                  <img src={image} alt={name} />
                  <span>
                    {name} <br />
                    <span style={{ color: '#67707D', fontSize: 14 }}>{subtitle}</span>
                  </span>
                </Link>
              ) : (
                <a
                  key={name}
                  href={path}
                  alt={name}
                  onClick={() => sendEvent({ cta: tabTitle, subMenu: name })}
                  target="_BLANK"
                  rel="noopener noreferrer"
                >
                  <img src={image} alt={name} />
                  <span>
                    {name} <br />
                    <span style={{ color: '#67707D', fontSize: 14 }}>{subtitle}</span>
                  </span>
                </a>
              )}
            </div>
          ))}
        </S.TabContent>
      </S.TabContainer>
    </S.Tab>
  );
};

export default Tab;
